import zenginCode from 'zengin-code';

/**
 * 全銀データ（zengin-code）の銀行名を暫定的に上書きするラッパー。
 *
 * 住信SBIネット銀行は 2026-08-03 に「ドコモSMTBネット銀行」へ商号変更した。
 * しかし zengin-code のデータ元が未反映のため、最新版でも銀行名は旧名のままになる。
 * サーバ側の同等の上書きは config/initializers/zengin_code_name_override.rb にある。
 * 上流反映後は両方を削除し、gem / npm を更新すること。
 *
 * name だけでなく kana / hira / roma も上書きする。
 * マイページの受取口座表示（BankAccountView）が name とあわせて kana も表示しており、
 * name だけを差し替えると「ドコモＳＭＴＢネット（スミシンエスビ－アイネツト）」と
 * 新旧が混ざった表示になってしまうため。
 *
 * カナ表記は全銀データ内の同種の表記に合わせている。
 * 全角ラテン文字は1文字ずつ読みに開き、長音は「－」、促音・拗音は大文字にする慣例。
 * 例: ＳＭＢＣ信託 → エスエムビ－シ－シンタク / ＤＢＳ → デイ－ビ－エス / ネット → ネツト。
 * これに倣い ＳＭＴＢ → エスエムテイ－ビ－ とした。
 *
 * searchAlias は SearchBox の検索用にのみ使うフィールド。
 * SearchBox は項目の全プロパティを部分一致で検索するため、ここに入れた語でヒットするようになる。
 * 表示には使われないので、候補リストの見た目には影響しない。
 *
 * 旧商号の表記・読みは searchAlias に移してある。
 * 旧商号での振込は2026-10-30まで読み替えられ、それまでは旧商号で銀行を探す顧客が相当数いるため、
 * 「住信SBI」「すみしん」「sumishin」でも引き続き検索できる必要がある。
 *
 * NOTE: 「ドコモの銀行」は個人向けサービスブランド名であり正式な銀行名ではない。
 * 表示名には使わず、検索語としてのみ拾う。
 */
const DOCOMO_SMTB_BANK_CODE = '0038';

const OLD_NAME_SEARCH_TERMS = [
  '住信ＳＢＩネット',
  'スミシンエスビ－アイネツト',
  'すみしんえすび－あいねつと',
  'sumishinesubi-ainetsuto'
];

const NEW_NAME_SEARCH_TERMS = [
  'ドコモ',
  'どこも',
  'docomo',
  'ドコモの銀行',
  'ＳＭＴＢ'
];

const zenginCodeWithOverride = {
  ...zenginCode,
  [DOCOMO_SMTB_BANK_CODE]: {
    ...zenginCode[DOCOMO_SMTB_BANK_CODE],
    name: 'ドコモＳＭＴＢネット',
    kana: 'ドコモエスエムテイ－ビ－ネツト',
    hira: 'どこもえすえむてい－び－ねつと',
    roma: 'dokomoesuemutei-bi-netsuto',
    searchAlias: [...OLD_NAME_SEARCH_TERMS, ...NEW_NAME_SEARCH_TERMS].join(' ')
  }
};

export default zenginCodeWithOverride;
